import { DigitalProductErrorInterface } from 'modules/digital-product/types/digital-product-interface'

export const defaultDigitalProductErrors: DigitalProductErrorInterface = {
  name: '',
  resources: [],
  pricePlans: [],
  confirmationEmail: {
    subject: '',
    body: '',
    fromName: '',
    fromEmail: '',
    previewText: '',
  },
}
